const m = window.require("discourse/models/category");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;